import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent } from '@mui/material';
import { LambdaWebFunctionDetails, LoadingFragment, PageTitle } from '@localstack/ui';
import { useRoutes, useAwsGetter } from '@localstack/services';

import { LambdaProps } from './types';
import { LambdaWebVersionGate } from './components/LambdaWebVersionGate';
import { WebFunctionTabs } from './components/WebFunctionTabs';

export const LambdaWebFunction = (props: LambdaProps): ReactElement => (
  <LambdaWebVersionGate {...props}>
    <LambdaWebFunctionContent {...props} />
  </LambdaWebVersionGate>
);

const LambdaWebFunctionContent = ({ Layout, clientOverrides, routes }: LambdaProps): ReactElement => {
  const { goto } = useRoutes();
  const { name = '' } = useParams<'name'>();
  const { data, isLoading, mutate } = useAwsGetter('LambdaWeb', 'getWebFunction', [{ functionName: name }], {
    clientOverrides,
  });
  return (
    <Layout
      documentTitle="Lambda: Web Function Details"
      tabs={<WebFunctionTabs routes={routes} functionName={name} clientOverrides={clientOverrides} />}
      title={
        <PageTitle
          title="Web Function Details"
          onMutate={mutate}
          breadcrumbs={[
            ['Lambda', () => goto(routes.RESOURCES_LAMBDA)],
            ['Web Functions', () => goto(routes.RESOURCES_LAMBDA_WEB_FUNCTIONS)],
            [name, null],
          ]}
        />
      }
    >
      <Card>
        <CardContent>
          <LoadingFragment loading={isLoading} variant="list" height={50} size={6}>
            <LambdaWebFunctionDetails data={data} />
          </LoadingFragment>
        </CardContent>
      </Card>
    </Layout>
  );
};
